














/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IPersonBase } from '@/api/types/response.types'

/* API */

export default Vue.extend({
  name: 'CalendarPersonPicker',
  props: {
    people: {
      type: Array as () => IPersonBase[],
      default: () => [] as IPersonBase[],
    },
    value: {
      type: Array as () => number[],
      default: () => [] as number[],
    },
  },

  computed: {
    internalValue: {
      get(): number[] {
        return this.value
      },
      set(value: number[]) {
        this.$emit('input', value)
      },
    },
  },
})
